import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/sections/Header";
import Hero from "./components/sections/Hero";
import Locations from "./components/sections/Locations";
import Services from "./components/sections/Services";
import Benefits from "./components/sections/Benefits";
import CTABanner from "./components/sections/CTABanner";
import Payments from "./components/sections/Payments";
import MapSection from "./components/sections/MapSection";
import Testimonials from "./components/sections/Testimonials";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="landing-root">
      <Header />
      <main>
        <Hero />
        <Locations />
        <Services />
        <Benefits />
        <CTABanner />
        <Payments />
        <MapSection />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
